import { Constants } from "constants/Constants";
import { getStoredData } from "./fnAsyncStorage";

type Props = {
  url: string;
  method: string;
  payload?: object | undefined;
  signal?: AbortSignal | null | undefined;
};

/**
 * Fonction pour récupérer des fichiers binaires depuis l'API
 * Structure similaire à fetchJSON mais adaptée pour les fichiers binaires
 */
export const fetchBinary = async ({ url, method, payload, signal }: Props) => {
  const apiUrl = Constants.API_URL;
  const token = await getStoredData("token");

  const headers = new Headers();
  const baseUrl = `${apiUrl}/${url}`;

  // Pour les requêtes GET de fichiers binaires, ne pas définir Content-Type
  // Pour les autres types de requêtes, on garde le même comportement que fetchJSON
  if (method !== "GET") {
    headers.append("Content-Type", "application/json");
  }

  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  const res = await fetch(baseUrl, {
    method,
    headers,
    signal,
    // Pour les requêtes GET, ne pas envoyer de body
    body: method !== "GET" ? JSON.stringify(payload) : undefined,
  });

  if (!res.ok) {
    const message = await res.text();

    let error: any;

    try {
      const response = JSON.parse(message);
      error = { message: response.error.message };
      response.error?.details?.errors?.forEach((err: any) => {
        error[err.path.join(".")] = err.message;
      });
    } catch (e) {
      error = { message };
    }

    throw error;
  }

  // Retourne un blob
  return res.blob();
};

export default fetchBinary;
